import { EndpointName } from '~/store/middlewares/rtkErrorNotifier/rtkErrorNotifier.type';

export const isRtkErrorNotifierExcludedEndpoint = (
  endpointName: EndpointName
) => {
  const rtkErrorNotifierExcludedEndpoints: EndpointName[] = [
    'postAuth',
    'getClientData',
    'getSessionStatus',
    'getBankAccounts',
    'getAspsps',
  ];

  return rtkErrorNotifierExcludedEndpoints.includes(endpointName);
};

export const isSentryNotifierExcludedEndpoint = (
  endpointName: EndpointName
) => {
  const sentryNotifierExcludedEndpoints: EndpointName[] = [];

  return sentryNotifierExcludedEndpoints.includes(endpointName);
};
